import Navbar from "@/components/event/Navbar";
import Hero from "@/components/event/Hero";
import Gallery from "@/components/event/Gallery";
import EventDetails from "@/components/event/EventDetails";
import MidCta from "@/components/event/MidCta";
import DressCodeFaq from "@/components/event/DressCodeFaq";
import TicketsMenu from "@/components/event/TicketsMenu";
import Footer from "@/components/event/Footer";
import StickyCta from "@/components/event/StickyCta";

const Index = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Gallery />
      <EventDetails />
      <MidCta />
      <DressCodeFaq />
      <TicketsMenu />
    </main>
    <Footer />
    <StickyCta />
  </>
);

export default Index;
